import React, { useContext, useState, useCallback } from "react";
import styled, { useTheme } from "styled-components";
import Button from "../UI/Button";
import { Body, Currency } from "../UI/Text";
import { Flex } from "reflexbox";
import AlertContext from "../../context/alert/AlertContext";

const LineImg = styled.img`
  max-width: 75px;
  max-height: 75px;
  width: auto;
  height: auto;
`;

const Quantity = ({ row, onProductClick }) => {
  const theme = useTheme();
  const [quantity, setQuantity] = useState(1);
  const { showFailureAlert } = useContext(AlertContext);

  const onAddClick = useCallback(() => {
    return row?.original?.isNonConfigurable
      ? onProductClick(row?.original?.ID, quantity)
      : onProductClick(row?.original?.ID);
  }, [onProductClick, quantity, row]);

  const onMinusClick = useCallback(
    (e) => {
      e.stopPropagation();
      return quantity > 1
        ? setQuantity(quantity - 1)
        : showFailureAlert("Cannot set quantity to a number less than 1.");
    },
    [quantity, showFailureAlert]
  );

  const onPlusClick = useCallback(
    (e) => {
      e.stopPropagation();
      
      return quantity + 1 <= row?.original?.quantityInStock
        ? setQuantity(quantity + 1)
        : showFailureAlert(
            "Cannot set quantity to a number greater than the number in stock."
          );
    },
    [quantity, row, showFailureAlert]
  );

  return (
    <>
      {row?.original?.isNonConfigurable ? (
        <Flex
          width="auto !important"
          height="100%"
          justifyContent="center"
          alignItems="center"
          key={row?.id + "|quantity"}
        >
          <Button
            iconName="faMinus"
            reverse
            title="Subtract 1 from Quantity"
            size="tiny"
            color={theme.secondary}
            onClick={onMinusClick}
          />

          <Body mx="0.25rem" bold center>
            {quantity}
          </Body>

          <Button
            iconName="faPlus"
            reverse
            title="Add 1 to Quantity"
            size="tiny"
            color={theme.secondary}
            onClick={onPlusClick}
          />
        </Flex>
      ) : null}

      <Button
        title={
          row?.original?.isNonConfigurable ? "Add Product" : "Configure Product"
        }
        color={
          row?.original?.isNonConfigurable ? theme.secondary : theme.primary
        }
        onClick={onAddClick}
        iconName={row?.original?.isNonConfigurable ? "faPlus" : "faPenRuler"}
      >
        {row?.original?.isNonConfigurable ? null : "Configure"}
      </Button>
    </>
  );
};

export function convertFromBase64(str) {
  return Buffer.from(str, "base64");
}

export const Columns = (onProductClick, pageView = false) => {
  const cols = [];
  if (pageView)
    cols.push({
      id: "img",
      data: (row) => {
        const { img, base64Image, ImageUrl, ID } = row || {};
        const image = img || base64Image || ImageUrl;
        return (
          <Body center>
            {!image ? null : ImageUrl ? (
              <LineImg
                src={`${window.location.protocol}//${window.location.host}${ImageUrl}`}
                alt={`Product #${ID}`}
              />
            ) : (
              <LineImg src={image} alt={`Product #${ID}`} />
            )}
          </Body>
        );
      },
      header: "Preview",
      size: { lg: 1, md: 1, sm: 0, xs: 0 },
    });
  cols.push(
    // {
    //   id: "ProductNumber",
    //   data: "ProductNumber",
    //   header: "Part #",
    //   size: { lg: 1, md: 0, sm: 0, xs: 0 },
    // },
    {
      id: "Name",
      data: ({ Name }) => <Body center>{Name}</Body>,
      size: { lg: pageView ? 1.5 : 2.5, md: 1, sm: 1, xs: 4 },
    },
    {
      id: "Description",
      data: "Description",
      size: { md: 3, sm: 0, xs: 0 },
    },
    {
      id: "Overview",
      data: ({ Overview }) => {
        const { 1: overview } = (Overview || "").split(">") || {};
        return <Body>{overview}</Body>;
      },
      size: { md: 0, sm: 0, xs: 0 },
    },
    {
      id: "RelatedItem",
      data: ({ RelatedItem }) => <Body center>{RelatedItem}</Body>,
      header: "Related Item",
      size: { md: 2, sm: 0, xs: 0 },
    },
    {
      id: "defaultPrice",
      data: ({ defaultPrice }) => <Currency value={defaultPrice} />,
      header: "Price",
      size: { md: 1.5, sm: 1, xs: 0 },
    },
    {
      id: "quantityInStock",
      data: (row) => <Body center>{row?.quantityInStock}</Body>,
      header: "In Stock (#)",
      size: { md: 1, sm: 0, xs: 0 },
    },
    {
      id: "Actions",
      display: (props) => (
        <Flex
          style={{ gap: "1rem" }}
          width={1}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Quantity row={props.row} onProductClick={onProductClick} />
        </Flex>
      ),
      header: pageView ? "" : "Add To Quote",
      sort: false,
      size: pageView ? { xs: -1 } : { lg: 3, md: 3, sm: 3, xs: 5 },
    }
  );
  return cols;
};
